const NOMINATION_FIELDS = /* GraphQL */ `
  id
  name
  headline
  about
  locationRaw
  locationCountryCode
  pictureUrl
  followerCount
  linkedinVanity
  experiences {
    id
    title
    company
    duration
    location
    employmentType
    startDate
    endDate
    isCurrent
    organizationPictureUrl
  }
  education {
    id
    school
    degree
    degreeName
    fieldOfStudy
    duration
    startDate
    endDate
    organizationPictureUrl
  }
  matchReasons
`;

export const ONBOARDING_V2_CONTEXT_Q = /* GraphQL */ `
  query OnboardingV2Context {
    onboardingV2Context {
      firstName
      school
      location
      plannedActions
    }
  }
`;

export const SUGGEST_HUMAN_Q = /* GraphQL */ `
  query SuggestHuman {
    suggestHuman { ${NOMINATION_FIELDS} }
  }
`;

export const HUMAN_CARD_Q = /* GraphQL */ `
  query HumanCard($id: ID!) {
    humanCard(id: $id) { ${NOMINATION_FIELDS} }
  }
`;

export const SUGGEST_TRIGGERS_Q = /* GraphQL */ `
  query SuggestTriggers {
    suggestTriggers {
      id
      label
      cadence
      prompt
    }
  }
`;

export const PEOPLE_STATS_Q = /* GraphQL */ `
  query PeopleStats {
    peopleStats {
      humanCount
      syncedCount
      queuedCount
      runningCount
      failedCount
    }
  }
`;

export const PEOPLE_HUMANS_Q = /* GraphQL */ `
  query PeopleHumans($limit: Int, $offset: Int, $status: String) {
    peopleHumans(limit: $limit, offset: $offset, status: $status) {
      id
      name
      headline
      linkedinVanity
      linkedinUrl
      locationRaw
      lastSyncedAt
      lastSyncMode
      syncStatus
      syncPriority
      lastSyncError
      status
    }
  }
`;

export const PEOPLE_ENQUEUE_SYNC_M = /* GraphQL */ `
  mutation PeopleEnqueueSync($vanity: String!) {
    peopleEnqueueSync(vanity: $vanity)
  }
`;

export const PEOPLE_TRIGGER_SYNC_M = /* GraphQL */ `
  mutation PeopleTriggerSync($humanId: ID!) {
    peopleTriggerSync(humanId: $humanId)
  }
`;

export const PEOPLE_RETRY_SYNC_M = /* GraphQL */ `
  mutation PeopleRetrySync($humanId: ID!) {
    peopleRetrySync(humanId: $humanId)
  }
`;

export const SET_CHOSEN_FAIRY_GODMOTHER_M = /* GraphQL */ `
  mutation SetChosenSuperconnector($input: ChosenSuperconnectorInput!) {
    setChosenSuperconnector(input: $input) {
      firstName
      lastName
      pictureUrl
      gender
    }
  }
`;

export const RECORD_MATCH_DECISION_M = /* GraphQL */ `
  mutation RecordMatchDecision($targetId: ID!, $decision: MatchDecision!) {
    recordMatchDecision(targetId: $targetId, decision: $decision)
  }
`;

// ─── Settings: device location + contact sync ────────────────────────

export const SYNC_CONTACTS_M = /* GraphQL */ `
  mutation SyncContacts($contacts: [ContactInput!]!) {
    syncContacts(contacts: $contacts) {
      matchCount
      totalCount
    }
  }
`;

export const UPDATE_MY_DEVICE_LOCATION_M = /* GraphQL */ `
  mutation UpdateMyDeviceLocation($latitude: Float!, $longitude: Float!) {
    updateMyDeviceLocation(latitude: $latitude, longitude: $longitude) {
      city
      countryCode
      latitude
      longitude
      updatedAt
    }
  }
`;

export const SET_MY_TIMEZONE_M = /* GraphQL */ `
  mutation SetMyTimezone($timezone: String!) {
    setMyTimezone(timezone: $timezone)
  }
`;

export const DELETE_MY_ACCOUNT_M = /* GraphQL */ `
  mutation DeleteMyAccount {
    deleteMyAccount
  }
`;
